<template>
  <div class="exchange_point_info">
    <h3>전환 정보</h3>
    <dl>
      <dt>전환 방식</dt>
      <dd>현금 캐시백</dd>
    </dl>
    <dl>
      <dt>전환 비율</dt>
      <dd>
        {{ pointInfo.pointName }} : 현금 = {{ exchangeCurrency.exchangeRate }}{{ pointInfo.pointUnitName }} :
        {{ isBasedUSD ? exchangeCurrency.secondExchangeRate : 1 }}원
      </dd>
      <dd class="msg">
        현금 캐시백은 1회 최소
        {{ this.addComma(exchangeCurrency.exchangeMinAmount) }}{{ pointInfo.pointUnitName }}
        부터 최대
        {{ this.addComma(exchangeCurrency.exchangeMaxAmount) }}{{ pointInfo.pointUnitName }}
        까지 가능하며,
        {{ this.addComma(exchangeCurrency.exchangeAmountUnit) }}{{ pointInfo.pointUnitName }} 단위로 전환 신청
        가능합니다.
      </dd>
    </dl>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mixin from '@/utils/mixin';

export default {
  mixins: [mixin],
  computed: {
    ...mapGetters(['serviceInfo']),
    ...mapGetters('point', ['pointInfo']),
    ...mapGetters('exchange', ['exchangeCurrency']),
    isBasedUSD() {
      // USD 기반 환율인지 여부
      return this.exchangeCurrency.secondExchangeRate;
    },
  },
};
</script>
<style lang="scss"></style>
